function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { withGenericConfig } from "/contexts/generic-config-context";
import MediaItem from "../media-item/media-item-component";
import { StyledItemsList } from "./items-list.component.scss";
const ItemsList = ({ items, direction })=>{
    return /*#__PURE__*/ _jsx(StyledItemsList, {
        className: "items-list-component",
        children: items.map((item, index)=>/*#__PURE__*/ _jsx("div", {
                className: "item-wrapper",
                children: /*#__PURE__*/ _jsx(MediaItem, _object_spread({
                    direction: direction
                }, item))
            }, `item_${index}`))
    });
};
ItemsList.defaultProps = {
    direction: "row"
};
export default withGenericConfig(ItemsList);
